import Vue from 'vue'
import VueRouter from 'vue-router'

import ClientWelcome from '../views/client/Welcome.vue'
import ClientSubscriptions from '../views/client/Subscriptions.vue'
import ClientClaim from '../views/client/Claim.vue'

import ShopLogin from '../views/shop/Login.vue'
import ShopEnrolment from '../views/shop/Enrolment.vue'

import { isLoggedIn } from '@/auth'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: ClientWelcome,
    meta: {
      title: 'MiCare - Déclarer un sinistre'
    }
  },
  {
    path: '/client',
    name: 'Client',
    component: ClientSubscriptions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/client/claim/:type/:subscription_id',
    name: 'ClientClaim',
    component: ClientClaim,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/shop/login',
    name: 'ShopLogin',
    component: ShopLogin
  },
  {
    path: '/shop/enrolment',
    name: 'Enrolment',
    component: ShopEnrolment,
    meta: {
      requiresShopAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Check shop auth
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresShopAuth) && !window.sessionStorage.getItem('shop_access_token')) {
    next('/shop/login?session=expired')
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn()) {
    window.sessionStorage.removeItem('access_token')
    next('/?session=expired')
  }

  next()
})


export default router
